import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Building2, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

// Animation component for text appearing line by line
const AnimatedParagraph = ({ children, delay = 0 }: { children: React.ReactNode; delay?: number }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <p
      className={`text-lg text-muted-foreground mb-6 leading-relaxed text-justify transition-all duration-1000 ease-out ${
        isVisible
          ? 'opacity-100 transform translate-y-0'
          : 'opacity-0 transform translate-y-4'
      }`}
    >
      {children}
    </p>
  );
};

const ForeignTrustBankingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <section className="pt-32 pb-20 bg-background">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gold/10 rounded-full mb-6">
              <Building2 className="h-8 w-8 text-gold-light" />
            </div>
            <h1 className="font-rockwell text-4xl md:text-5xl font-semibold text-primary mb-6">
              Open Foreign Trust Bank Accounts on US Soil
            </h1>
            <p className="text-xl text-muted-foreground leading-relaxed">
              Private management of securities and federal reserve notes
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <AnimatedParagraph delay={200}>
              Foreign trust banking allows you to operate private accounts on US soil while maintaining complete privacy and sovereignty. These accounts are established through private trusts that operate outside the traditional banking system's reporting requirements.
            </AnimatedParagraph>
            
            <AnimatedParagraph delay={600}>
              Our banking services provide secure, private management of your assets while protecting your wealth from government interference and maintaining your sovereign status.
            </AnimatedParagraph>

            <div className="mt-12 p-8 bg-primary/5 rounded-lg border border-primary/10">
              <h3 className="font-rockwell text-2xl font-semibold text-primary mb-4">
                Secure Your Financial Privacy
              </h3>
              <p className="text-muted-foreground mb-6">
                Establish private banking relationships that protect your assets and maintain your sovereignty.
              </p>
              <div className="flex flex-col gap-4 items-start">
                <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground">
                  <Link to="/work-with-us" className="flex items-center gap-2">
                    Work with Us
                    <ArrowRight className="h-5 w-5" />
                  </Link>
                </Button>
                <Button asChild variant="outline">
                  <Link to="/education" className="flex items-center gap-2">
                    Do It Yourself
                    <ArrowRight className="h-5 w-5" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ForeignTrustBankingPage;